import React, { useState } from 'react';

export interface FolderCollapsibleSectionProps {
  title: React.ReactNode;
  /** Shown next to the title, e.g. "4 events". */
  count?: React.ReactNode;
  defaultOpen?: boolean;
  children: React.ReactNode;
  testId?: string;
}

/**
 * KD-3842 bordered section of the client folder page whose header (title and
 * chevron) folds its content away, like the Travelers and Activity log cards
 * of the mockup.
 */
export default function FolderCollapsibleSection({
  title,
  count = null,
  defaultOpen = true,
  children,
  testId,
}: FolderCollapsibleSectionProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <section className="w-full overflow-hidden rounded-md border border-solid border-border bg-card">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        data-testid={testId}
        className={`flex w-full cursor-pointer items-center gap-2.5 border-none bg-transparent px-4 py-3 text-left ${
          open ? 'border-0 border-b border-solid border-border' : ''
        }`}
      >
        <span className="text-sm font-bold text-gray-900">{title}</span>
        {count !== null && count !== undefined && (
          <span className="text-xs text-gray-500">{count}</span>
        )}
        <span className="flex-1" />
        <i
          className={`fa-solid fa-chevron-down text-xs text-gray-500 transition-transform ${
            open ? 'rotate-180' : ''
          }`}
          aria-hidden="true"
        />
      </button>
      {open && <div className="p-4">{children}</div>}
    </section>
  );
}
